<template>
  <div>
    <v-card>
      <v-card-title>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Procurar" single-line hide-details></v-text-field>
      </v-card-title>

      <v-data-table :headers="tableHeader" :items="tableRows" :search="search" class="elevation-1 custom-row-size" style="background-color: #fcfcfc" disable-sort>
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{ tableTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>

        <template v-slot:[`item.nomeItemNaoPadronizado`]="props">
          <td :style="getCellStyles(props.item.nomeItemNaoPadronizado)">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="abrirModalProdutosRelacionados(props.item)" v-bind="attrs" v-on="on" :color="props.item.cor ? props.item.cor : 'red'" dark rounded class="text-wrap body-2" style="width: 400px; display: inline-block" :style="getButtonLineHeight(props.item.nomeItemNaoPadronizado)">
                  {{ props.item.nomeItemNaoPadronizado }}
                </v-btn>
              </template>
              <span>Produto padronizado: {{ formataProdutoPadronizado(props.item.nomeProdutoPadronizado) }}</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>

      <DialogCustom :openDialog="dialogCustom.openDialog" :sizeDialog="dialogCustom.sizeDialog" :titleDialog="dialogCustom.titleDialog" v-on:dialog-close="fecharDialog" v-on:dialog-action="concluirPadronizacao">
        <v-form v-model="tudoValido">
          <v-row>
            <v-col cols="12" class="py-2">
              <div class="tituloInfo">Produto Selecionado</div>

              <div v-if="!produtoSelecionado.nomeItemNaoPadronizado">
                <v-skeleton-loader type="heading" class="skeletonTexto"></v-skeleton-loader>
              </div>
              <div :class="produtoSelecionado.nomeItemNaoPadronizado ? 'descricaoInfo' : 'textoVazio'" v-else>{{ produtoSelecionado.nomeItemNaoPadronizado }}</div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0">
              <v-radio-group row v-model="filtragem.procuraPorNome">
                <v-radio label="Produtos Relacionados" :value="true"></v-radio>
                <v-radio label="Todos os Produtos" :value="false"></v-radio>
              </v-radio-group>
            </v-col>

            <v-expand-transition>
              <v-col v-if="mostrarProdutosParaVincular" cols="12" class="pt-0">
                <v-autocomplete
                  v-model="numeroItemSistemaUnidade"
                  :items="listaProdutosParaVincular"
                  label="Produtos"
                  :loading="!listaProdutosParaVincular.length"
                  :no-data-text="autocompleteData.semValoresProdutosVinculados"
                  autocomplete="off"
                  :rules="[rules.requeridoAutocomplete]"
                ></v-autocomplete>
              </v-col>
            </v-expand-transition>

            <v-expand-transition>
              <v-col cols="12" v-if="mostrarProdutoFamilia">
                <v-autocomplete v-model="indicadorStatusFamilia" :items="listaIndicadorStatusFamilia" label="Selecione a Familia do Produto" autocomplete="off" clearable></v-autocomplete>
              </v-col>
            </v-expand-transition>
          </v-row>
        </v-form>
      </DialogCustom>
    </v-card>

    <v-snackbar v-model="snackbar.habilitar" :timeout="3000" :color="snackbar.cor">
      {{ snackbar.texto }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackbar.habilitar = false"> Fechar </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import store from "@/store/index";
import DialogCustom from "../components/DialogCustom.vue";

export default {
  components: {
    DialogCustom,
  },

  props: {
    tableTitle: String,
    tableHeader: Array,
    tableRows: Array,
    isStatus: Boolean,
    isDel: Boolean,
  },

  data: () => ({
    search: "",

    snackbar: {
      habilitar: false,
      cor: null,
      texto: null,
    },

    rules: {
      requerido: (value) => (value != null && value != "") || "Requer o campo!",
      requeridoStatus: (value) => (value != 0 && value != null && value != "") || "Por favor, altere o status!",
      requeridoAutocomplete: (value) => value != null || "Campo requerido!",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    dialogCustom: {
      openDialog: false,
      sizeDialog: "600",
      titleDialog: "",
      botaoAcaoVisivel: false,
      botaoAtivo: false,
    },

    filtragem: {
      procuraPorNome: false,
      numeroEndereco: store.state.numeroEndereco,
      nomeItem: null,
    },

    autocompleteData: {
      semValoresProdutosVinculados: "Carregando, por favor aguarde...",
    },

    loading: false,
    tudoValido: false,
    menu: [],

    mostrarProdutosParaVincular: false,
    mostrarProdutoFamilia: false,

    numeroItemSistemaUnidade: null,
    indicadorStatusFamilia: null,
    nomeProdutoSelecionado: null,
    dataVerificada: null,

    produtoSelecionado: {
      editarProduto: false,
      numeroItemDispensaUnidade: null,
      numeroItemSistemaUnidade: null,
      numeroItemUnidade: null,
      numeroItem: null,
      nomeItem: null,
      nomeItemSistema: null,
      nomeProdutoPadronizado: null,
      lote: null,
      validade: null,
      indicadorStatusFamilia: null,
      quantidadeAtual: null,
      quantidadeDispensada: null,
      cor: "red",
      padronizado: false,
    },

    listaProdutosParaVincular: [],
    listaIndicadorStatusFamilia: [
      { text: "Medicamentos", value: 1 },
      { text: "Materiais", value: 2 },
      { text: "Psicotropicos", value: 3 },
      { text: "Saneantes", value: 4 },
      { text: "Cosmeticos", value: 5 },
      { text: "Nutrição", value: 6 },
      { text: "Antimicrobianos", value: 7 },
      { text: "Amostra Grátis", value: 8 },
      { text: "Maleta de Emergência", value: 9 },
      { text: "Doação", value: 10 },
      { text: "Teste Rápido", value: 11 },
      { text: "USO INTERNO", value: 12 },
    ],
  }),

  watch: {
    "filtragem.procuraPorNome"() {
      this.mostrarProdutosParaVincular = false;
      this.listarProdutosDisponiveis();
    },

    numeroItemSistemaUnidade() {
      this.mostrarProdutoFamilia = true;
    },

    tudoValido() {
      this.dialogCustom.botaoAtivo = !this.tudoValido;
    },
  },

  methods: {
    async listarProdutosDisponiveis() {
      try {
        const response = await axios.put("searchItemSistemaUnidade", this.filtragem, this.config);

        if (response.data.length == 0) {
          this.autocompleteData.semValoresProdutosVinculados = "Não há produtos relacionados.";
        }

        this.listaProdutosParaVincular = response.data.map((produtoSelecionado) => {
          return {
            value: produtoSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade,
            text: produtoSelecionado.itemSistema.nomeItemSistema,
            numeroItemSistemaUnidade: produtoSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade,
            nomeItemSistema: produtoSelecionado.itemSistema.nomeItemSistema,
          };
        });

        this.mostrarProdutosParaVincular = true;
      } catch (error) {
        console.log(error);
        this.mensagemErroModal.text = error.response.data.message;
        this.mensagemErroModal.erro = true;
      }
    },

    async abrirModalProdutosRelacionados(produto) {
      this.loading = true;

      try {
        this.produtoSelecionado = produto;

        if (produto.numeroItemSistemaUnidade) {
          this.mostrarProdutosParaVincular = false;
          this.produtoSelecionado.numeroItemSistemaUnidade = produto.numeroItemSistemaUnidade;
          this.produtoSelecionado.nomeItemSistema = produto.nomeItemSistema;
          this.produtoSelecionado.nomeProdutoPadronizado = produto.nomeItemSistema;
          this.produtoSelecionado.indicadorStatusFamilia = produto.indicadorStatusFamilia;
          this.numeroItemSistemaUnidade = produto.numeroItemSistemaUnidade;
          this.indicadorStatusFamilia = produto.indicadorStatusFamilia;
          this.mostrarProdutoFamilia = produto.indicadorStatusFamilia != null ? true : false;
          this.filtragem.procuraPorNome = false;

          await this.listarProdutosDisponiveis();
        } else {
          this.mostrarProdutosParaVincular = false;
          this.produtoSelecionado.numeroItemSistemaUnidade = null;
          this.produtoSelecionado.nomeItemSistema = null;
          this.produtoSelecionado.nomeProdutoPadronizado = null;
          this.produtoSelecionado.indicadorStatusFamilia = produto.indicadorStatusFamilia;
          this.numeroItemSistemaUnidade = null;
          this.indicadorStatusFamilia = produto.indicadorStatusFamilia;
          this.mostrarProdutoFamilia = produto.indicadorStatusFamilia != null ? true : false;
          this.filtragem.procuraPorNome = false;

          await this.listarProdutosDisponiveis();
        }

        this.filtragem.nomeItem = produto.nomeItemNaoPadronizado;
      } catch (error) {
        console.log(error);
      } finally {
        this.dialogCustom.titleDialog = "Padronizar Produto";
        this.dialogCustom.botaoAtivo = !this.tudoValido;
        this.dialogCustom.botaoAcaoVisivel = true;
        this.dialogCustom.openDialog = true;
        this.loading = false;
      }
    },

    concluirPadronizacao() {
      try {
        if (this.numeroItemSistemaUnidade) {
          this.snackbar.texto = "Sucesso! Nome do produto padronizado.";
          this.snackbar.cor = "success";
          this.snackbar.habilitar = true;

          const produtoSelecionadoLista = this.listaProdutosParaVincular.filter((produto) => produto.numeroProduto == this.numeroProduto)[0];
          
          this.produtoSelecionado.numeroItemSistemaUnidade = this.numeroItemSistemaUnidade;
          this.produtoSelecionado.nomeItemSistema = produtoSelecionadoLista.nomeItemSistema;
          this.produtoSelecionado.nomeProdutoPadronizado = produtoSelecionadoLista.nomeItemSistema;
          this.produtoSelecionado.indicadorStatusFamilia = this.indicadorStatusFamilia;
          this.produtoSelecionado.padronizado = true;
          this.produtoSelecionado.cor = "green";
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.numeroProduto = null;
        this.mostrarProdutosParaVincular = false;
        this.dialogCustom.openDialog = false;
      }
    },

    fecharDialog() {
      try {
        this.numeroProduto = null;
        this.mostrarProdutosParaVincular = false;

        this.snackbar.texto = "Padronização cancelada.";
        this.snackbar.cor = "info";
        this.snackbar.habilitar = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.dialogCustom.openDialog = false;
      }
    },

    //#region FORMATADORES
    formataProdutoPadronizado(nome) {
      if (nome) {
        return nome;
      } else {
        return "Não padronizado!";
      }
    },

    formatarData(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    analizarData(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    getCellStyles(content) {
      const lines = Math.ceil(content.length / 26); // Ajuste o número de caracteres por linha conforme necessário
      const height = 24 * lines;
      return `height: ${height}px;`;
    },

    getButtonLineHeight(content) {
      const lines = Math.ceil(content.length / 26); // Ajuste o número de caracteres por linha conforme necessário
      const height = 18 * lines;
      return `height: ${height}px;`;
    },
    //#endregion

    //#region EMITS
    emitDataTableUpdateStatusRowEvent(row) {
      this.$emit("datatable-updatestatusrow", row);
    },

    emitDataTableDeleteRowEvent(row) {
      this.$emit("datatable-deleterow", row);
    },
    //#endregion
  },
};
</script>

<style>
.tituloInfo {
  font-size: smaller;
  font-weight: 500;
  color: rgba(85, 85, 85, 0.7);
}
.descricaoInfo {
  font-size: larger;
  font-weight: 400;
  color: rgb(35, 35, 35);
}
.titulo {
  font-size: large;
  font-weight: 500;
  color: #212121;
}
.textoVazio {
  color: rgba(0, 0, 0, 0.3);
}
.skeletonTexto {
  height: 24px;
  width: 460px;
  padding-right: 8px;
}
.custom-row-size td {
  height: auto;
  white-space: normal;
}
</style>
